var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"787a586dd7402317cac85f6c41d0bd8772da4b46"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pmt-portal@primariatm"]={id:"787a586dd7402317cac85f6c41d0bd8772da4b46"};
      